import type { JSX } from 'react';
import { Button, Icon, Menu, MenuRadioGroup, RadioMenuItem } from '@wistia/ui';
import type { CommentingSortType } from '../Store/MediaStore';
import { useMediaStore, MediaStoreSelectors, commentingSorts } from '../Store/MediaStore';

const SORT_OPTIONS = [
  { label: 'Timecode', value: 'timecode' },
  { label: 'Newest', value: 'newest' },
  { label: 'Oldest', value: 'oldest' },
] as const;

const getSortLabel = (commentingSort: CommentingSortType): string => {
  if (commentingSort === commentingSorts.newest) {
    return SORT_OPTIONS[1].label;
  }
  if (commentingSort === commentingSorts.oldest) {
    return SORT_OPTIONS[2].label;
  }
  return SORT_OPTIONS[0].label;
};

const getSortValue = (commentingSort: CommentingSortType): string => {
  if (commentingSort === commentingSorts.newest) {
    return SORT_OPTIONS[1].value;
  }
  if (commentingSort === commentingSorts.oldest) {
    return SORT_OPTIONS[2].value;
  }
  return SORT_OPTIONS[0].value;
};

export const CommentsSortChooser = (): JSX.Element => {
  const commentingSort = useMediaStore(MediaStoreSelectors.getCommentingSort);
  const { setCommentingSort } = useMediaStore(MediaStoreSelectors.getActions);
  const currentLabel = getSortLabel(commentingSort);
  const currentValue = getSortValue(commentingSort);

  const handleValueChange = (value: string) => {
    let orderBy = commentingSorts.timecode;
    switch (value) {
      case 'timecode':
        orderBy = commentingSorts.timecode;
        break;
      case 'newest':
        orderBy = commentingSorts.newest;
        break;
      case 'oldest':
        orderBy = commentingSorts.oldest;
        break;
      default:
        break;
    }
    setCommentingSort(orderBy);
  };

  return (
    <Menu
      trigger={
        <Button
          variant="soft"
          size="sm"
          leftIcon={<Icon type="sort" />}
          rightIcon={<Icon type="caret-down" />}
        >
          {currentLabel}
        </Button>
      }
    >
      <MenuRadioGroup
        value={currentValue}
        onValueChange={handleValueChange}
      >
        {SORT_OPTIONS.map((option) => (
          <RadioMenuItem
            key={option.value}
            value={option.value}
          >
            {option.label}
          </RadioMenuItem>
        ))}
      </MenuRadioGroup>
    </Menu>
  );
};
